export const AuthErrorCode = {
  UserAccountNotFound: 'hs-user-accounts-2300',
  CurrentPasswordIncorrect: 'hs-user-accounts-2301',
  ResetTokenInvalid: 'hs-user-accounts-2302',
  InvitationTokenInvalid: 'hs-user-accounts-2303',
  PasswordPolicyViolation: 'hs-user-accounts-2304',

  /**
   * An invitation link was asked for a user who already set a password. Such an account is reached
   * through a password reset - a second invitation would overwrite the password they chose.
   */
  AccountAlreadyActivated: 'hs-user-accounts-2307',

  /**
   * Every credential failure on the /auth/* endpoints: unknown farm / user / veterinary contact,
   * wrong password, account without a password set. Deliberately indistinguishable so the API
   * cannot be used to enumerate accounts - do not try to derive a more specific reason from it.
   */
  AuthenticationFailed: 'hs-auth-2400',

  /**
   * The submitted password was correct but the account is locked out. `details` carries the lockout
   * expiry as an ISO-8601 string.
   */
  AccountLocked: 'hs-auth-2401',

  /**
   * The submitted password was correct but an administrator has deactivated the account. Like
   * AccountLocked it is only returned once the password has been proved, so it cannot be used to
   * enumerate accounts. Unlike a lockout it does not expire - only an administrator can lift it.
   */
  AccountDeactivated: 'hs-auth-2402'
} as const;

/**
 * Errors from the farm user administration endpoints (`/users/{id}/deactivate` and `/activate`).
 */
export const UserAdminErrorCode = {
  NotFound: 'hs-users-3200',
  NotAllowedToModify: 'hs-users-3201',
  CannotDeactivateSelf: 'hs-users-3202',
  Deactivated: 'hs-users-3203',

  /** The address is taken by a deactivated user, who should be reactivated instead of re-invited. */
  DeactivatedEmailExists: 'hs-users-3204'
} as const;
